import { Route, Routes } from 'react-router';
import { Layout, Logout } from '@/features/logout';

export const Router = () => (
  <Routes>
    <Route path="/*" element={<Layout />}>
      <Route index element={<Logout />} />
    </Route>
  </Routes>
);
